import './index.less';
import { Button, Col, Dropdown, Row, Tooltip } from 'antd';
import { DownOutlined, StopOutlined } from '@ant-design/icons';
import FontSpecialEffectItem from '@/components/WorkSpace/components/FontSpecialEffectItem';
import FontStroke from './FontStroke/FontStroke';
import FontBackground from './FontBackground/FontBackground';
import FontShadow from './FontShadow/FontShadow';
import { useContext, useState } from 'react';
import { FileCenterContext, IFileCenterContext } from '@/common/components/FileCenterProvider';
import { fontSpecialEffectsConfig } from './constants';
import SpecialEffectsSelectPanel from './SpecialEffectsSelectPanel/SpecialEffectsSelectPanel';
import classNames from 'classnames';
import { RGBA } from '@/common/constants/interfaces';

function FontSpecialEffects() {

    const { selectedWatermarkId, updateWatermark } = useContext<IFileCenterContext>(FileCenterContext);
    const [selectedIndex, setSelectedIndex] = useState<number>(-1)
    const [firstIndex, setFirstIndex] = useState<number>(0)

    const handleClearSpecialEffects = () => {
        setSelectedIndex(-1)
        if (selectedWatermarkId) {
            updateWatermark(selectedWatermarkId, { fontColor: RGBA.fromHex('#000'), stroke: null, background: null, shadow: null })
        }
    }

    const handlePanelItemSelect = (index: number) => {
        setSelectedIndex(index)
        setFirstIndex(index)
    }

    const handleSelect = (value: any) => {
        setSelectedIndex(value)
    }

    const secondIndex = (firstIndex + 1) % fontSpecialEffectsConfig.length
    const thirdIndex = (firstIndex + 2) % fontSpecialEffectsConfig.length
    const threeItems = [fontSpecialEffectsConfig[firstIndex], fontSpecialEffectsConfig[secondIndex], fontSpecialEffectsConfig[thirdIndex]]

    return (
        <div className="font-special-effects-container">
            <Row className='line-container'>
                <Col span={6} className='text'>
                    特效
                </Col>
                <Col span={18}>
                    <div className='button-group'>
                        <Tooltip placement="bottom" title='清除特效'>
                            <Button shape="circle" size="small" icon={<StopOutlined />} onClick={handleClearSpecialEffects} />
                        </Tooltip>
                        {
                            threeItems.map((item, index) => {
                                const curIndex = firstIndex + index
                                const selected = curIndex === selectedIndex
                                const cs = classNames('font-special-effects-btn', { 'font-special-effects-btn-selected': selected })
                                return (
                                    <FontSpecialEffectItem
                                        key={curIndex}
                                        value={curIndex}
                                        className={cs}
                                        selected={selected}
                                        fontSizeProp={16}
                                        {...item}
                                        onSelect={handleSelect} />
                                )
                            })
                        }
                        <Dropdown
                            trigger={['click']}
                            dropdownRender={() => (
                                <SpecialEffectsSelectPanel selectedIndex={selectedIndex} fontSpecialEffectsConfig={fontSpecialEffectsConfig} onSelect={handlePanelItemSelect} />
                            )}
                        >
                            <DownOutlined className='btn-down-outlined' />
                        </Dropdown>
                    </div>

                </Col>
            </Row>
            <FontStroke />
            <FontBackground />
            <FontShadow />
        </div >
    );
}

export default FontSpecialEffects;